import OrderSearch from '../models/requisitions/PaginatedOrderSearchRequisition.model';
import ORDER_SEARCH_INITIALIZER from './initializers/SearchFieldsInitializer';

const STORAGE_KEY = 'orderSearchParams';

const stringValue = (value: unknown, fallback: string): string =>
  typeof value === 'string' ? value : fallback;

export const loadOrderSearchParams = (): OrderSearch | null => {
  try {
    const savedParams = localStorage.getItem(STORAGE_KEY);

    if (!savedParams) return null;

    const parsed = JSON.parse(savedParams) as Partial<OrderSearch>;

    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return null;
    }

    return {
      page:
        typeof parsed.page === 'number' &&
        Number.isInteger(parsed.page) &&
        parsed.page > 0
          ? parsed.page
          : ORDER_SEARCH_INITIALIZER.page,
      pedidoId: stringValue(
        parsed.pedidoId,
        ORDER_SEARCH_INITIALIZER.pedidoId,
      ),
      emissaoInicial: stringValue(
        parsed.emissaoInicial,
        ORDER_SEARCH_INITIALIZER.emissaoInicial,
      ),
      emissaoFinal: stringValue(
        parsed.emissaoFinal,
        ORDER_SEARCH_INITIALIZER.emissaoFinal,
      ),
      cliente: stringValue(
        parsed.cliente,
        ORDER_SEARCH_INITIALIZER.cliente,
      ),
      vendedorId: stringValue(
        parsed.vendedorId,
        ORDER_SEARCH_INITIALIZER.vendedorId || '',
      ),
      rascunho:
        typeof parsed.rascunho === 'boolean'
          ? parsed.rascunho
          : ORDER_SEARCH_INITIALIZER.rascunho,
    };
  } catch {
    return null;
  }
};

export const saveOrderSearchParams = (params: OrderSearch): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(params));
  } catch {
    // The search still works in memory when browser storage is unavailable.
  }
};
